export default __webpack_public_path__ + "media/yo-yo-mobile.d81d367898f68ed7cf8ac45ddeaa0675.gif";